import { RCAlertBox } from '@reverbdotcom/cadence/components';
import React from 'react';
import I18n from 'i18n-js';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import SpeakerIcon from '@reverbdotcom/cadence/images/brand/report-orange.svg';

export function StatementPaymentNeededBanner() {
  return (
    <RCAlertBox
      type="error"
    >
      <div className="g-container g-container--cycle d-flex mobile-d-block fx-align-center fx-justify-between">
        <div className="d-flex fx-align-center fx-grow g-col-mobile-12">
          <img
            style={{ width: '5rem' }}
            className="mr-2"
            src={SpeakerIcon}
            alt={I18n.t('discovery.payStatement.statementPaymentNeededBanner.speakerAlt')}
          />
          <div>
            <Translate
              text="discovery.payStatement.statementPaymentNeededBanner.headline"
              tag="h2"
              className="weight-bold"
            />
            <Translate text="discovery.payStatement.statementPaymentNeededBanner.message" />
          </div>
        </div>
      </div>
    </RCAlertBox>
  );
}

export default StatementPaymentNeededBanner;
